import React from 'react';
import {
  AiOutlineDownload,
  AiOutlineExperiment,
  AiOutlineFileDone,
  AiOutlineFontColors,
  AiOutlineMergeCells,
  AiOutlineSetting,
} from 'react-icons/ai';

const routesConfig = [
  {
    id: 'app',
    title: '',
    messageId: '',
    type: 'group',
    children: [
      {
        id: 'symbols',
        title: 'Symbols',
        messageId: 'symbols.label',
        type: 'item',
        icon: <AiOutlineFontColors />,
        path: '/symbols',
      },
      {
        id: 'quotes',
        title: 'Quotes',
        messageId: 'quotes.label',
        type: 'item',
        icon: <AiOutlineMergeCells />,
        path: '/quotes',
      },
      {
        id: 'watchlist',
        title: 'Watchlist',
        messageId: 'watchlist.label',
        type: 'item',
        icon: <AiOutlineFileDone />,
        path: '/watchlist',
      },
      {
        id: 'conditions',
        title: 'Conditions',
        messageId: 'condition.label',
        type: 'item',
        icon: <AiOutlineExperiment />,
        path: '/conditions',
      },
      // {
      //   id: 'events',
      //   title: 'Events',
      //   messageId: 'events.label',
      //   type: 'item',
      //   icon: <FaRegListAlt />,
      //   path: '/events',
      // },
      {
        id: 'settings',
        title: 'Settings',
        messageId: 'settings.label',
        type: 'item',
        icon: <AiOutlineSetting />,
        path: '/settings',
      },
      {
        id: 'downloads',
        title: 'Downloads & Instructions',
        messageId: 'downloads.label',
        type: 'item',
        icon: <AiOutlineDownload />,
        path: '/downloads',
      },
    ],
  },
];
export default routesConfig;
